import { IndividualResponseSchema } from '../schemas'
import { http } from './http'
import { auth } from './auth'
import { parseWithZod } from '../utils/parse-with-zod'

export const individuals = {
  create: async (dealId: number, payload: { name: string; email: string }) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.post(
      `${regionHost}/api/individuals`,
      { individual: { ...payload, deal_id: dealId, signing_packages: [] } },
      dealId,
    )
    return parseWithZod(IndividualResponseSchema, result).individual
  },

  update: async (
    id: number,
    payload: {
      name: string
      email?: string
      address_street?: string
      address_city?: string
      address_state?: string
      address_postal_code?: string
      address_country?: string
      include_address_on_signature_block?: boolean
    },
    dealId: number,
  ) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.put(
      `${regionHost}/api/individuals/${id}`,
      { individual: { ...payload, deal_id: dealId } },
      dealId,
    )
    return parseWithZod(IndividualResponseSchema, result).individual
  },

  delete: async (id: number, dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    await http.delete(`${regionHost}/api/individuals/${id}`, dealId)
  },
}
